"use client";

export default function AboutLinda() {
  return <section id="about-linda" className="relative min-h-[80vh] flex items-center justify-center py-32 overflow-hidden bg-cover bg-center !bg-[url(http://bodyconcept-allendorf-eder.de/wp-content/uploads/2026/05/EMP-Chair-Pro-one-anthrazit-anthrazit116-scaled.jpg)]">
            <div className="absolute inset-0 bg-black/40 z-0" />
            
            <div className="container relative z-10 mx-auto px-4 md:px-6 max-w-7xl">
                <div className="flex flex-col items-center text-center">
                    <span className="font-sans text-primary-foreground mb-6 block text-xl font-medium tracking-widest uppercase">
                        EIN STARKER BECKENBODEN AUF KNOPFDRUCK
                    </span>

                    <h1 className="font-default font-bold mb-8 tracking-wide leading-tight text-4xl max-w-4xl text-[rgba(233,254,255,1)] md:text-6xl lg:text-7xl">
                        EMP Chair Pro. <br />
                        <span className="text-secondary">Der sanfte Weg zu einem starken Beckenboden</span>
                    </h1>

                    <p className="font-default text-lg md:text-2xl font-light text-white/90 leading-relaxed max-w-3xl mb-12">
                        Erleben Sie die Revolution der Beckentherapie. Ohne Anstrengung, voll bekleidet und in entspannter Atmosphäre erzielen Sie Ergebnisse, die mit herkömmlichem Training kaum erreichbar sind.
                    </p>

                    <div className="mt-16 pt-8 w-full">
                        <a href="https://www.beckenboden-behandlung.com/allendorf" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-sans rounded-lg transition-all duration-300 shadow-lg !font-extrabold !bg-[rgba(102,196,195,1)] hover:scale-105">
                            Jetzt Probesitzen!
                        </a>
                    </div>
                </div>
            </div>
        </section>;
}